import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-anlegen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleAnlegenEffects {

    RolleAnlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_ANLEGEN),
        mergeMap((x: ac.PostRolleAnlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleAnlegen(x.rolleAnlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleAnlegenErfolgreichAction(result, x.rolleAnlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleAnlegenFehlerAction(error, x.rolleAnlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
